<template>
  <div class="flex flex-col gap-2">
    <template v-if="cartStore.items.length <= 0">
      <QItem class="cart-item--empty">
        PLEASE SELECT ITEM
      </QItem>
    </template>
    <template v-else-if="$route.name.includes('duotone-balls')">
      <slot v-bind="cartStore.items" />
    </template>
    <template v-else>
      <template v-for="item in cartStore.items">
        <slot v-bind="item" />
      </template>
    </template>
  </div>
</template>
<script setup>
import { useCartStore } from '@/stores/cart.js'

defineProps({
  component: {
    type: Object,
    default: null
  }
})
const cartStore = useCartStore()
</script>
